var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "url(#paint0_linear_1236_25384)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8457 52.334C56.6543 52.334 57.3105 52.9902 57.3105 53.7988C57.3105 54.6074 56.6543 55.2637 55.8457 55.2637C55.0372 55.2637 54.3809 54.6074 54.3809 53.7988C54.3809 52.9902 55.0372 52.334 55.8457 52.334Z",
    fill: "#EDAD0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3184 28.8965C16.6671 28.8965 17.7598 29.9893 17.7598 31.3379C17.7598 32.6865 16.6671 33.7793 15.3184 33.7793C13.9697 33.7793 12.877 32.6865 12.877 31.3379C12.877 29.9893 13.9697 28.8965 15.3184 28.8965Z",
    fill: "#EDAD0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2612 14.8125C16.9186 14.8711 18.3823 15.7373 19.273 17.0332C19.3179 17.0996 19.3618 17.167 19.4049 17.2354C19.4478 17.3037 19.4888 17.374 19.5279 17.4443C19.8043 17.9395 20.0006 18.4854 20.1022 19.0635C20.152 19.3525 20.1783 19.6494 20.1783 19.9531H15.2604C11.9576 19.9531 11.775 15.0117 15.0729 14.8203C15.1353 14.8164 15.1979 14.8145 15.2612 14.8125Z",
    fill: "#CBE9FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5449 49.8672H47.6964H52.4277C52.4277 53.1592 50.2705 54.8984 47.6943 54.8984H26.1348H26.0918C27.2861 54.7813 28.4336 54.3105 29.2832 53.4766C30.1318 52.6416 30.6826 51.4424 30.6826 49.8672H47.5449Z",
    fill: "#CBE9FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.587 14.8086H20.1789H44.7785H44.8263C46.3243 14.8086 47.5431 16.0244 47.5431 17.5215C47.5431 30.6553 47.545 38.3291 47.545 49.8672H30.6827C30.6827 51.4424 30.1319 52.6416 29.2833 53.4766C28.4338 54.3105 27.2863 54.7812 26.0919 54.8984H24.9103C22.5205 54.7119 20.2256 53.0273 20.1788 49.8936V19.9531C20.1788 19.6494 20.1523 19.3525 20.1017 19.0635C20.0011 18.4854 19.8038 17.9395 19.5274 17.4443C19.4884 17.374 19.4474 17.3037 19.4044 17.2354C19.3623 17.167 19.3174 17.0996 19.2725 17.0332C18.3818 15.7373 16.9181 14.8711 15.2607 14.8125C15.2285 14.8115 15.1974 14.8086 15.166 14.8086H15.4336H15.587Z",
    fill: "#E4F4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7422 14.248C50.1467 14.248 50.4746 13.9201 50.4746 13.5156C50.4746 13.1111 50.1467 12.7832 49.7422 12.7832C49.3377 12.7832 49.0098 13.1111 49.0098 13.5156C49.0098 13.9201 49.3377 14.248 49.7422 14.248Z",
    fill: "#76CAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 57.2168C19.8733 57.2168 20.2012 56.8889 20.2012 56.4844C20.2012 56.0799 19.8733 55.752 19.4688 55.752C19.0642 55.752 18.7363 56.0799 18.7363 56.4844C18.7363 56.8889 19.0642 57.2168 19.4688 57.2168Z",
    fill: "#76CAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 24.0137C18.4084 24.0137 18.7363 23.6858 18.7363 23.2812C18.7363 22.8767 18.4084 22.5488 18.0039 22.5488C17.5994 22.5488 17.2715 22.8767 17.2715 23.2812C17.2715 23.6858 17.5994 24.0137 18.0039 24.0137Z",
    fill: "#76CAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0508 42.5684C16.4553 42.5684 16.7832 42.2404 16.7832 41.8359C16.7832 41.4314 16.4553 41.1035 16.0508 41.1035C15.6463 41.1035 15.3184 41.4314 15.3184 41.8359C15.3184 42.2404 15.6463 42.5684 16.0508 42.5684Z",
    fill: "#76CAFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 24.9902H24.1074C23.8378 24.9902 23.6191 24.7716 23.6191 24.502C23.6191 24.2323 23.8378 24.0137 24.1074 24.0137H43.6387C43.9084 24.0137 44.127 24.2323 44.127 24.502C44.127 24.7716 43.9084 24.9902 43.6387 24.9902Z",
    fill: "#4E5356"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 28.8965H24.1074C23.8378 28.8965 23.6191 28.6778 23.6191 28.4082C23.6191 28.1386 23.8378 27.9199 24.1074 27.9199H43.6387C43.9084 27.9199 44.127 28.1386 44.127 28.4082C44.127 28.6778 43.9084 28.8965 43.6387 28.8965Z",
    fill: "#4E5356"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 32.8027H24.1074C23.8378 32.8027 23.6191 32.5841 23.6191 32.3145C23.6191 32.0448 23.8378 31.8262 24.1074 31.8262H43.6387C43.9084 31.8262 44.127 32.0448 44.127 32.3145C44.127 32.5841 43.9084 32.8027 43.6387 32.8027Z",
    fill: "#4E5356"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 36.709H24.1074C23.8378 36.709 23.6191 36.4904 23.6191 36.2207C23.6191 35.951 23.8378 35.7324 24.1074 35.7324H43.6387C43.9084 35.7324 44.127 35.951 44.127 36.2207C44.127 36.4904 43.9084 36.709 43.6387 36.709Z",
    fill: "#4E5356"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 40.6152H24.1074C23.8378 40.6152 23.6191 40.3967 23.6191 40.127C23.6191 39.8572 23.8378 39.6387 24.1074 39.6387H43.6387C43.9084 39.6387 44.127 39.8572 44.127 40.127C44.127 40.3967 43.9084 40.6152 43.6387 40.6152Z",
    fill: "#4E5356"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 24.5,
    r: 7.5,
    fill: "#EDAD0C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22L51.5 27.5",
    stroke: "black",
    strokeWidth: 0.846154,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 22L46 27.5",
    stroke: "black",
    strokeWidth: 0.846154,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_25384",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHist);
export default __webpack_public_path__ + "static/media/no-req-hist.399237118286fd8b3153e01b95427f3c.svg";
export { ForwardRef as ReactComponent };